import SimpleDate from 'app/common/classes/simple-date'
import { extractDateFromColumnKey } from './create-column-keys'
import { Entity } from './types'

const headerCells = {
  [Entity.Count]: '№',
  [Entity.Category]: 'Категории питающихся',
  [Entity.Total]: 'Всего',
}

export const createHeaderCells = (sourceDateFormat: string, outputDateFormat: string) => {
  return new Proxy(headerCells, {
    get: function (target, property) {
      const res = target[property]
      if (!res) {
        const key = extractDateFromColumnKey(property as string)
        return new SimpleDate(key, sourceDateFormat).getStringFormatted(outputDateFormat)
      }
      return res || ''
    },
  })
}
